// ==========================
// Layout & DOM batching utility
// ==========================
window.Layout = (() => {
  const reads = [], writes = [];
  const flush = () => {
    requestAnimationFrame(() => {
      reads.forEach(fn => fn());
      writes.forEach(fn => fn());
      reads.length = writes.length = 0;
    });
  };
  return {
    read: fn => { reads.push(fn); flush(); },
    write: fn => { writes.push(fn); flush(); }
  };
})();

// ==========================
// Scroll/Resize Debounce Utility
// ==========================
window.Debounce = (fn, delay = 50) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), delay);
  };
};

// ==========================
// BFCACHE-friendly pagehide cleanup
// ==========================
window.addEventListener('pagehide', () => {
  // Example: cleanup timers or WebSockets
  if (window.appSocket) {
    window.appSocket.close();
  }
  if (window.mainInterval) {
    clearInterval(window.mainInterval);
  }
});
